import { BigNumber } from 'ethers'
import { base, optimism } from 'viem/chains'

import { PerpsProvider } from 'state/futures/types'

import { DEFAULT_PERPS_PROVIDER } from './futures'

export const GWEI_UNIT = 1000000000
export const GWEI_DECIMALS = 9
export const ETH_UNIT = 1000000000000000000
export const STALL_TIMEOUT = 5000
export type GasLimitEstimate = BigNumber | null

export const SUPPORTED_NETWORKS = [
	1, // Ethereum (mainnet)
	10, // Optimism (mainnet)
	11155420, // Optimism Sepolia(testnet)
	8453, // Base (mainnet)
	84532, // Base Sepolia (testnet)
]

export const SUPPORTED_NETWORKS_MAINNET = [
	1, // Ethereum (mainnet)
	10, // Optimism (mainnet)
	8453, // Base (mainnet)
]

export const SUPPORTED_WATCHER_MODE_NETWORKS = [1, 10, 8453]

export const SUPPORTED_V3_CHAINS = [8453, 84532]
export const SUPPORTED_V2_CHAINS = [10, 11155420]

export const DEFAULT_CHAIN = DEFAULT_PERPS_PROVIDER === PerpsProvider.SNX_V3 ? base : optimism
